import { Spin } from 'antd';

interface WrapperPageProps extends React.HTMLAttributes<HTMLDivElement> {
	isLoading?: boolean;
}

export const WrapperPage = ({
	isLoading = false,
	className,
	...props
}: WrapperPageProps) => (
	<Spin spinning={isLoading}>
		<div className={`py-6 px-0 md:p-10 w-full ${className}`} {...props}>
			{props.children}
		</div>
	</Spin>
);
